var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"specialInfo",attrs:{"title":_vm.infoObject.title}},[_c('b-card-text',[_vm._v(" "+_vm._s(_vm.infoObject.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }